export const oauthTypes = {
  DISCORD: 'DISCORD',
  GOOGLE: 'GOOGLE',
  TWITCH: 'TWITCH',
};
